import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import HomeHeader from '../../components/homeHeader/index.vue'
import verifyEmailModal from '../../components/verifyEmailModal/index.vue'
import verifyPhoneModal from '../../components/verifyPhonModal/index.vue'
import GuestService from '../../services/GuestService'
import UserService from '../../services/UserService'
import { showErrorToast, showSuccessToast } from '../../services/UI'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  name: 'signUp',
  data () {
    return {
      modalActive: false,
      modalPhoneActive: false,
      salutation: '',
      name: '',
      orgName: '',
      email: '',
      phone: '',
      role: '',
      companyType: '',
      website: '',
      checkbox: false,
      salutations: [],
      companyTypes: []
    }
  },
  mounted () {
    // window.analytics.page('SignUp')
    window.analytics.identify('SignUp', {
      path: '/sign_up'
    })
  },
  async created () {
    this.salutations = await GuestService.getEnum('EnumSalutationType')
    // this.salutation = this.salutations[0]
    this.companyTypes = await GuestService.listCompanyTypes()
  },
  components: {
    HomeHeader,
    verifyEmailModal,
    verifyPhoneModal
  },
  methods: {
    uploadModal () {
      this.modalActive = true
      document.body.classList.add('overlay-bg')
    },
    verifyPhone () {
      this.modalPhoneActive = true
      document.body.classList.add('overlayBg')
    },
    close (bool) {
      if (!bool) this.modalActive = !this.modalActive
      else this.modalActive = null
      document.body.classList.remove('overlay-bg')
    },
    closePhone (bool) {
      if (!bool) this.modalPhoneActive = !this.modalPhoneActive
      else this.modalPhoneActive = null
      document.body.classList.remove('overlayBg')
    },
    validateEmail () {
      return /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
    },
    invalidColor () {
      return this.validateEmail() ? {} : { color: 'red' }
    },
    async verifyPhones () {
      if (!this.phone || !this.phone.length || this.phone.length !== 10) {
        this.error = 'Invalid number passed.'
        showErrorToast(this, this.error)
        return
      }
      const resend = false
      const verifyToken = await UserService.verifyPhone(this.phone, resend)
      console.log(verifyToken)
      if (verifyToken.error && verifyToken.error.errors[0].message) {
        return showErrorToast(this, 'Phone number already registered')
      }
      this.verifyPhone()
    },
    async sendMail () {
      if (!this.email || !this.email.length || !this.validateEmail()) {
        this.error = 'Invalid email passed.'
        showErrorToast(this, this.error)
        return
      }
      const verifyToken = await UserService.verifyEmail(this.email)
      console.log(verifyToken)
      if (verifyToken.error && verifyToken.error.errors[0].message) {
        return showErrorToast(this, 'Email already registered')
      }
      this.uploadModal()
    },
    async submit () {
      if (!this.salutation || !this.name || !this.orgName || !this.email || !this.role || !this.companyType) {
        // console.log('salution:', this.salutation.key)
        showErrorToast(this, 'All fields are required')
        return
      } else if (!this.checkbox) {
        showErrorToast(this, 'Please click on term and condition')
        return
      }
      // console.log(this.validateEmail())
      if (!this.validateEmail()) {
        showErrorToast(this, 'Enter valid Email Address')
        return
      }
      const regexExp = /^[6-9]\d{9}$/gi
      if (!regexExp.test(this.phone)) {
        showErrorToast(this, 'Enter a valid Mobile number')
        return
      }
      const res = await UserService.signup(this.salutation.key, this.name, this.orgName, this.email, this.role, this.companyType, this.website, this.phone)
      if (res.error && res.error.errors[0].message === 'User exists!') {
        showErrorToast(this, 'Same Email ID/ Phone number already registered')
        return
      }
      if (res.error && res.error.errors[0].message === 'Not possible!') {
        showErrorToast(this, 'Verify email first')
        return
      }
      if (res.error && res.error.errors[0].message === 'mobile not verified!') {
        showErrorToast(this, 'Please verify mobile')
        return
      }
      if (res) {
        // console.log('Account created')
        showSuccessToast(this, 'Thank you for registering. Email has been sent to you for next steps')
        this.$router.push('/sign_in')
      } else {
        showErrorToast(this, 'Error while creating account')
      }
    }
  }
}
